// extracted by mini-css-extract-plugin
module.exports =  {"container":"c85e813ac9--container--L3gTN","title":"c85e813ac9--title--bhfMm","answer":"c85e813ac9--answer--exfhA"};